export default {"src":"/_next/static/media/impact-grid-horizontal.a403941d.svg","height":1482,"width":1717,"blurWidth":0,"blurHeight":0};